export const movies = [
  {
    id: "m01",
    title: "星际归途",
    year: 2024,
    genres: ["科幻", "剧情"],
    region: "美国",
    duration: "142 分钟",
    rating: 9.1,
    views: 1286000,
    updatedAt: "2024-12-18",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%2C%20lone%20astronaut%20silhouette%20against%20a%20glowing%20nebula%20and%20distant%20planets%2C%20deep%20blue%20and%20teal%20cosmic%20tones%2C%20dramatic%20rim%20lighting%2C%20high%20detail%2C%20atmospheric%20depth%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-01&orientation=portrait",
    logline: "当家园成为遥不可及的记忆，一名宇航员必须穿越星海找回回家的坐标。",
    synopsis: "一场突如其来的空间风暴切断了远航舰队的归途，独自漂流在深空的导航员陈默，依靠一段残缺的星图与地球最后的信号展开自救。在漫长的孤独航行中，他不断回忆起地球上的亲人，也逐渐发现这场灾难背后隐藏着更大的秘密。影片以冷静克制的镜头语言，探讨了人类在浩瀚宇宙中的渺小与坚持。",
  },
  {
    id: "m02",
    title: "都市风云",
    year: 2025,
    genres: ["动作", "犯罪"],
    region: "中国香港",
    duration: "128 分钟",
    rating: 8.7,
    views: 1543000,
    updatedAt: "2025-03-22",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20art%2C%20rain-soaked%20neon%20city%20skyline%20at%20night%2C%20silhouette%20of%20a%20determined%20man%20in%20a%20trench%20coat%2C%20moody%20blue%20and%20amber%20reflections%2C%20dramatic%20lighting%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-02&orientation=portrait",
    logline: "霓虹熄灭之前，他要在一个夜晚里扳倒整座城市的暗流。",
    synopsis: "资深刑警高朗在一次卧底行动中身份暴露，成为黑白两道共同追杀的猎物。为了洗清冤屈并保护线人的家人，他必须在四十八小时内穿过层层陷阱，揭开一场横跨金融与黑帮的巨大阴谋。雨水、霓虹与枪火交织出这座都市最真实的面孔。",
  },
  {
    id: "m03",
    title: "笑闹一家亲",
    year: 2023,
    genres: ["喜剧", "剧情"],
    region: "中国大陆",
    duration: "112 分钟",
    rating: 8.2,
    views: 976000,
    updatedAt: "2023-09-05",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%20art%2C%20cheerful%20bright%20living%20room%20scene%20with%20colorful%20props%20and%20confetti%2C%20warm%20sunny%20tones%2C%20playful%20lighthearted%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-03&orientation=portrait",
    logline: "三代同堂的出租屋里，一场荒诞又温暖的搬家闹剧就此上演。",
    synopsis: "为了给即将出国的小女儿办一场体面的生日会，抠门的外公、手忙脚乱的中年父母和古灵精怪的邻居们轮番登场，把一个普通的周末搅成了鸡飞狗跳的喜剧现场。吵闹之下，藏着的是这一家人笨拙却真挚的爱。",
  },
  {
    id: "m04",
    title: "春日恋歌",
    year: 2024,
    genres: ["爱情", "剧情"],
    region: "日本",
    duration: "118 分钟",
    rating: 8.9,
    views: 1102000,
    updatedAt: "2024-06-11",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20art%2C%20couple%20silhouette%20beneath%20cherry%20blossom%20trees%20at%20golden%20sunset%2C%20soft%20pink%20and%20warm%20light%2C%20dreamy%20bokeh%2C%20tender%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-04&orientation=portrait",
    logline: "樱花只开一季，而有些心动，恰好赶上了最好的时节。",
    synopsis: "在樱花飘落的小镇上，面包店学徒与旧书店主理人因一本写满批注的旧书结缘。他们在春日的街道、雨后的屋檐和静谧的旧书店里慢慢靠近，也各自面对着关于梦想与告别的抉择。这是一个关于相遇、错过与珍惜的温柔故事。",
  },
  {
    id: "m05",
    title: "暗夜追踪",
    year: 2025,
    genres: ["悬疑", "犯罪"],
    region: "韩国",
    duration: "134 分钟",
    rating: 8.8,
    views: 1367000,
    updatedAt: "2025-05-02",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20thriller%20movie%20poster%20art%2C%20shadowy%20foggy%20alley%20with%20a%20single%20streetlamp%2C%20faint%20human%20silhouette%20walking%20away%2C%20cold%20teal%20and%20dark%20tones%2C%20tense%20mood%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-05&orientation=portrait",
    logline: "每一段雾里的脚印，都在指向那个谁都不愿提起的夜晚。",
    synopsis: "一桩十二年前的悬案因新的线索被重新翻开，年轻检察官与即将退休的老刑警联手追查。随着调查深入，他们发现所有证据都指向一个庞大的利益网络，而真相的代价，可能比他们想象的更为沉重。",
  },
  {
    id: "m06",
    title: "深海奇缘",
    year: 2023,
    genres: ["冒险", "剧情"],
    region: "英国",
    duration: "126 分钟",
    rating: 8.5,
    views: 842000,
    updatedAt: "2023-11-19",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%20art%2C%20underwater%20scene%20with%20sun%20rays%20piercing%20deep%20blue%20ocean%20and%20a%20diver%20silhouette%20among%20coral%2C%20mysterious%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-06&orientation=portrait",
    logline: "当她潜入最深的海沟，才发现那里藏着一个等待被唤醒的世界。",
    synopsis: "海洋生物学家苏珊在一次意外中接触到一片从未被记录的深海生态，为解开其中的谜团，她与经验丰富的潜航员组成小队深入海沟。幽暗的深蓝之下，是人类的渺小，也是自然最慷慨的馈赠。",
  },
  {
    id: "m07",
    title: "森林小勇士",
    year: 2024,
    genres: ["动画", "冒险"],
    region: "中国大陆",
    duration: "96 分钟",
    rating: 8.6,
    views: 1035000,
    updatedAt: "2024-08-01",
    poster: "https://readdy.ai/api/search-image?query=Animated%20family%20movie%20poster%20art%2C%20cute%20cartoon%20animals%20in%20a%20lush%20magical%20forest%20with%20glowing%20fireflies%2C%20vibrant%20green%20and%20warm%20golden%20light%2C%20whimsical%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-07&orientation=portrait",
    logline: "一只胆小的小松鼠，要用勇气守护整片森林的秋天。",
    synopsis: "秋天即将结束，森林里的小动物们正忙着储备过冬的粮食。最小、最胆小的松鼠豆豆意外卷入一场守护家园的行动，在朋友们的帮助下，他一步步战胜内心的恐惧，成为了大家眼中的小勇士。",
  },
  {
    id: "m08",
    title: "迷雾庄园",
    year: 2022,
    genres: ["恐怖", "悬疑"],
    region: "美国",
    duration: "108 分钟",
    rating: 7.9,
    views: 663000,
    updatedAt: "2022-10-28",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20movie%20poster%20art%2C%20abandoned%20gothic%20mansion%20wrapped%20in%20thick%20fog%20under%20a%20pale%20moon%2C%20bare%20twisted%20trees%2C%20cold%20desaturated%20tones%2C%20eerie%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-08&orientation=portrait",
    logline: "那座庄园的门一旦推开，就再也没有人愿意提起里面发生过什么。",
    synopsis: "一群年轻人受邀前往偏远山区的老庄园参加聚会，却被突如其来的浓雾困在其中。随着夜晚降临，庄园里尘封的往事逐一浮现，他们必须在天亮之前找出离开的唯一方法。",
  },
  {
    id: "m09",
    title: "岁月留声",
    year: 2024,
    genres: ["剧情"],
    region: "中国大陆",
    duration: "121 分钟",
    rating: 9.0,
    views: 789000,
    updatedAt: "2024-04-16",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20art%2C%20elderly%20hands%20holding%20an%20old%20vinyl%20record%20in%20soft%20window%20light%2C%20warm%20nostalgic%20sepia%20tones%2C%20emotional%20quiet%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-09&orientation=portrait",
    logline: "一张老唱片，把跨越半生的思念重新放回了唱机上。",
    synopsis: "退休的音乐教师林伯在整理旧物时，翻出一张尘封多年的黑胶唱片。循着唱片里的旋律，他重新走回那些被时间掩埋的记忆，也与多年未解的亲情达成了和解。这是一部关于记忆、时间与告别的温情之作。",
  },
  {
    id: "m10",
    title: "铁血黎明",
    year: 2023,
    genres: ["战争", "剧情"],
    region: "俄罗斯",
    duration: "156 分钟",
    rating: 8.4,
    views: 712000,
    updatedAt: "2023-05-09",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20war%20movie%20poster%20art%2C%20soldiers%20silhouettes%20advancing%20across%20a%20smoky%20battlefield%20at%20dawn%2C%20orange%20fire%20glow%20against%20dark%20sky%2C%20gritty%20dramatic%20lighting%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-10&orientation=portrait",
    logline: "黎明来临之前，总要有人先一步走进黑夜。",
    synopsis: "在战火最激烈的那段岁月里，一支被遗忘的小队奉命守住一座不起眼的高地。他们在绝境中相互扶持，用血肉之躯为后方争取了宝贵的时间。影片以群像叙事呈现普通人在战争中的选择与坚守。",
  },
  {
    id: "m11",
    title: "龙脊传说",
    year: 2025,
    genres: ["奇幻", "冒险"],
    region: "美国",
    duration: "148 分钟",
    rating: 9.2,
    views: 1678000,
    updatedAt: "2025-07-14",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20movie%20poster%20art%2C%20colossal%20dragon%20coiled%20around%20misty%20mountain%20peaks%2C%20glowing%20golden%20scales%2C%20epic%20sweeping%20scale%2C%20dramatic%20skies%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-11&orientation=portrait",
    logline: "当最后一条巨龙苏醒，被遗忘的龙脊山脉重新成为了世界的中心。",
    synopsis: "传说中守护世界的巨龙沉睡了千年，年轻的守卫者意外获得一段龙语传承，被迫踏上寻找真相的旅程。他要翻越险峻的龙脊山脉，集结昔日的盟友，赶在黑暗降临之前唤醒沉睡的守护者。",
  },
  {
    id: "m12",
    title: "罪案档案",
    year: 2024,
    genres: ["犯罪", "悬疑"],
    region: "美国",
    duration: "129 分钟",
    rating: 8.6,
    views: 934000,
    updatedAt: "2024-10-03",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20movie%20poster%20art%2C%20detective%20desk%20with%20scattered%20case%20files%2C%20revolver%20and%20dim%20desk%20lamp%2C%20moody%20noir%20green%20and%20amber%20tones%2C%20tense%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-12&orientation=portrait",
    logline: "尘封的卷宗里，藏着一段谁也不敢翻开的真相。",
    synopsis: "一宗看似普通的失踪案，牵出了一系列环环相扣的旧案。经验丰富的办案警官在整理档案时发现了被刻意忽略的细节，随着真相逐步浮出水面，他也被卷入一场关于正义与代价的艰难抉择。",
  },
  {
    id: "m13",
    title: "极速逃亡",
    year: 2025,
    genres: ["动作", "冒险"],
    region: "美国",
    duration: "118 分钟",
    rating: 8.3,
    views: 1456000,
    updatedAt: "2025-08-27",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20art%2C%20speeding%20muscle%20car%20on%20a%20wet%20highway%20at%20night%20with%20motion%20blur%2C%20neon%20reflections%2C%20dynamic%20energy%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-13&orientation=portrait",
    logline: "油门踩到底的那一刻，退路就已经被远远甩在了身后。",
    synopsis: "退役赛车手为救出被绑架的弟弟，被迫替一群亡命之徒完成一场横跨数个城市的亡命飙车。一路上警笛、陷阱与背叛接连不断，他必须凭借对赛道的直觉，在下一次红灯亮起之前找出真正的幕后之人。",
  },
  {
    id: "m14",
    title: "幸福快递",
    year: 2024,
    genres: ["喜剧", "爱情"],
    region: "中国大陆",
    duration: "104 分钟",
    rating: 8.1,
    views: 856000,
    updatedAt: "2024-02-14",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20movie%20poster%20art%2C%20cheerful%20delivery%20courier%20running%20with%20colorful%20parcels%20through%20a%20sunny%20town%20street%2C%20bright%20warm%20tones%2C%20lighthearted%20playful%20mood%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-14&orientation=portrait",
    logline: "一个总送错地址的快递员，却把幸福一次次送到了对的人手上。",
    synopsis: "小镇快递员小宇总是记不清门牌号，却意外促成了好几段奇妙的缘分。当他自己也陷入一场阴差阳错的心动时，才发现有些包裹，送对地址远不如送对人心重要。轻松幽默之中，是一份温暖的人间烟火。",
  },
  {
    id: "m15",
    title: "时光信笺",
    year: 2023,
    genres: ["爱情", "剧情"],
    region: "中国台湾",
    duration: "113 分钟",
    rating: 8.7,
    views: 801000,
    updatedAt: "2023-12-24",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20art%2C%20vintage%20letters%20and%20a%20pocket%20watch%20on%20a%20wooden%20table%20beside%20a%20rainy%20window%2C%20warm%20soft%20light%2C%20nostalgic%20tender%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-15&orientation=portrait",
    logline: "如果能寄一封信给十年前的自己，你最想写下什么？",
    synopsis: "整理老宅的女主角偶然发现一沓写给未来的信，写信的人却始终没有等到回音。循着信中的线索，她走进了两段跨越时空的遗憾，也在寻找答案的过程中，学会了与过去温柔和解。",
  },
  {
    id: "m16",
    title: "量子边界",
    year: 2025,
    genres: ["科幻", "悬疑"],
    region: "美国",
    duration: "139 分钟",
    rating: 8.9,
    views: 1423000,
    updatedAt: "2025-06-18",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%2C%20futuristic%20glass%20city%20with%20floating%20geometric%20structures%20and%20glowing%20blue%20energy%20lines%2C%20sleek%20high%20tech%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-16&orientation=portrait",
    logline: "当现实可以被计算，谁才是真正的旁观者？",
    synopsis: "年轻物理学家在一次实验事故中，发现自己的记忆开始出现无法解释的裂缝。为了找回真相，她潜入一座由算法驱动的研究城市，在量子与现实交错的边界上，揭开一个足以颠覆认知的实验。",
  },
  {
    id: "m17",
    title: "无声证词",
    year: 2024,
    genres: ["悬疑", "剧情"],
    region: "韩国",
    duration: "122 分钟",
    rating: 8.5,
    views: 768000,
    updatedAt: "2024-09-09",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%20art%2C%20dim%20interrogation%20room%20with%20a%20single%20hanging%20lamp%20over%20an%20empty%20chair%2C%20cold%20grey%20and%20blue%20tones%2C%20tense%20mysterious%20mood%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-17&orientation=portrait",
    logline: "唯一能开口作证的人，却选择了永远沉默。",
    synopsis: "一桩没有任何目击者的案件，唯一的线索指向一位失去语言能力的关键人物。负责调查的探员必须用最笨拙也最真诚的方式，走进对方的沉默世界，在证据之外，寻找那份被埋没的证词。",
  },
  {
    id: "m18",
    title: "大漠孤影",
    year: 2022,
    genres: ["冒险", "剧情"],
    region: "中国大陆",
    duration: "131 分钟",
    rating: 8.2,
    views: 645000,
    updatedAt: "2022-07-30",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%20art%2C%20lone%20traveler%20silhouette%20crossing%20vast%20golden%20desert%20dunes%20at%20sunset%2C%20long%20shadows%2C%20warm%20orange%20tones%2C%20epic%20lonely%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-18&orientation=portrait",
    logline: "穿越整片大漠，只为把一句承诺带给远方的人。",
    synopsis: "为完成故人的遗愿，一位孤独的行者独自踏上穿越沙漠的旅程。缺水、风暴与迷途接踵而至，他在无边的金黄里与自己的执念对话，也在最荒凉的地方，遇见了最温暖的人心。",
  },
  {
    id: "m19",
    title: "云端之城",
    year: 2025,
    genres: ["动画", "奇幻"],
    region: "日本",
    duration: "102 分钟",
    rating: 8.8,
    views: 1089000,
    updatedAt: "2025-04-25",
    poster: "https://readdy.ai/api/search-image?query=Animated%20adventure%20movie%20poster%20art%2C%20whimsical%20floating%20city%20among%20soft%20clouds%20with%20airships%20and%20bright%20sky%2C%20pastel%20blue%20and%20warm%20light%2C%20dreamy%20uplifting%20mood%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-19&orientation=portrait",
    logline: "住在云端的少年，要带着一整个城市找回久违的风。",
    synopsis: "天空之上漂浮着一座依赖风能运转的小城，当风突然停息，城中的少年决定驾着自制飞艇去寻找传说中会呼吸的云海。一路上他结识了形形色色的伙伴，也明白了勇气与梦想真正的重量。",
  },
  {
    id: "m20",
    title: "血色回廊",
    year: 2023,
    genres: ["恐怖", "悬疑"],
    region: "西班牙",
    duration: "99 分钟",
    rating: 7.7,
    views: 588000,
    updatedAt: "2023-08-15",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20movie%20poster%20art%2C%20long%20dark%20corridor%20with%20flickering%20lights%20and%20a%20faint%20red%20glow%20at%20the%20end%2C%20peeling%20walls%2C%20cold%20desaturated%20tones%2C%20dread%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-20&orientation=portrait",
    logline: "走廊尽头的那盏灯，每到午夜都会为一个名字亮起。",
    synopsis: "为调查姐姐的离奇失踪，女主角住进了那栋传闻不断的老公寓。走廊的灯光在深夜反复闪烁，一段被封锁的旧日视频逐渐揭开谜底，而她要面对的不只是恐惧，还有被隐藏多年的真相。",
  },
  {
    id: "m21",
    title: "平凡之光",
    year: 2024,
    genres: ["剧情"],
    region: "中国大陆",
    duration: "117 分钟",
    rating: 8.9,
    views: 734000,
    updatedAt: "2024-11-08",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20art%2C%20small%20town%20street%20at%20dusk%20with%20a%20lone%20figure%20under%20warm%20streetlights%2C%20gentle%20nostalgic%20tones%2C%20quiet%20emotional%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-21&orientation=portrait",
    logline: "平凡的每一天，都有人在认真地把它过成光。",
    synopsis: "小镇邮差、面馆老板和远道而来的支教老师，三条看似无关的人生轨迹在一个雨夜悄然交汇。影片用细碎而真实的日常，讲述普通人如何在平凡里彼此照亮、彼此支撑。",
  },
  {
    id: "m22",
    title: "钢铁防线",
    year: 2025,
    genres: ["战争", "动作"],
    region: "英国",
    duration: "145 分钟",
    rating: 8.6,
    views: 998000,
    updatedAt: "2025-02-19",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20war%20movie%20poster%20art%2C%20armored%20tank%20silhouettes%20on%20a%20stormy%20plain%20with%20dramatic%20clouds%2C%20cold%20steel%20blue%20and%20ember%20orange%2C%20gritty%20epic%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-22&orientation=portrait",
    logline: "钢铁铸成的防线可以被攻破，但信念不会。",
    synopsis: "在一次关键战役中，一支装甲小队被命令死守最后一道防线。面对压倒性的兵力，老兵与新兵在硝烟里完成了一场关于责任与成长的交接。影片用极具压迫感的战场镜头，呈现战争中的人性光辉。",
  },
  {
    id: "m23",
    title: "幻境之门",
    year: 2024,
    genres: ["奇幻", "冒险"],
    region: "新西兰",
    duration: "137 分钟",
    rating: 9.0,
    views: 1215000,
    updatedAt: "2024-12-30",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20movie%20poster%20art%2C%20ancient%20glowing%20portal%20archway%20in%20an%20enchanted%20forest%2C%20magical%20blue%20and%20gold%20light%2C%20mystical%20atmosphere%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-23&orientation=portrait",
    logline: "推开那扇门之后，她回到了所有故事开始的地方。",
    synopsis: "少女在祖父留下的老宅中发现了通往幻境的门，为了寻找失踪的兄长，她踏入了这个由传说拼成的世界。在旅途中她结识了忠诚的守护者，也渐渐明白，真正的力量来自于愿意为他人挺身而出的那一刻。",
  },
  {
    id: "m24",
    title: "都市猎手",
    year: 2023,
    genres: ["犯罪", "动作"],
    region: "中国香港",
    duration: "124 分钟",
    rating: 8.4,
    views: 877000,
    updatedAt: "2023-06-27",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20movie%20poster%20art%2C%20shadowy%20figure%20on%20a%20rooftop%20overlooking%20a%20sprawling%20night%20city%2C%20neon%20lights%20below%2C%20moody%20blue%20and%20amber%20tones%2C%20high%20detail%2C%20clean%20simple%20background&width=400&height=600&seq=yw-film-24&orientation=portrait",
    logline: "在这座不夜城里，没有人知道谁是猎人，谁是猎物。",
    synopsis: "一名身手了得却身份成谜的赏金猎人接下了一桩危险的任务，目标是一个在城市暗面游走的犯罪集团。随着线索层层推进，他被迫直面自己的过去，也重新定义了何为真正的正义。",
  },
];

export const heroSlides = [
  {
    id: "m11",
    title: "龙脊传说",
    year: 2025,
    genres: ["奇幻", "冒险"],
    image: "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20film%20still%2C%20enormous%20dragon%20flying%20over%20misty%20mountain%20range%20at%20golden%20sunrise%2C%20epic%20sweeping%20landscape%2C%20dramatic%20light%2C%20high%20detail&width=1600&height=900&seq=yw-hero-01&orientation=landscape",
    logline: "当最后一条巨龙苏醒，被遗忘的龙脊山脉重新成为了世界的中心。",
  },
  {
    id: "m02",
    title: "都市风云",
    year: 2025,
    genres: ["动作", "犯罪"],
    image: "https://readdy.ai/api/search-image?query=Cinematic%20action%20film%20still%2C%20rain-soaked%20neon%20city%20street%20at%20night%2C%20silhouette%20walking%20toward%20camera%2C%20colorful%20reflections%20on%20wet%20asphalt%2C%20moody%20dramatic%20light%2C%20wide%20shot%2C%20high%20detail&width=1600&height=900&seq=yw-hero-02&orientation=landscape",
    logline: "霓虹熄灭之前，他要在一个夜晚里扳倒整座城市的暗流。",
  },
  {
    id: "m01",
    title: "星际归途",
    year: 2024,
    genres: ["科幻", "剧情"],
    image: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20still%2C%20astronaut%20walking%20on%20a%20distant%20alien%20planet%20under%20a%20giant%20ringed%20planet%2C%20sweeping%20desert%20and%20glowing%20sky%2C%20epic%20wide%20shot%2C%20dramatic%20light%2C%20high%20detail&width=1600&height=900&seq=yw-hero-03&orientation=landscape",
    logline: "当家园成为遥不可及的记忆，一名宇航员必须穿越星海找回回家的坐标。",
  },
  {
    id: "m06",
    title: "深海奇缘",
    year: 2023,
    genres: ["冒险", "剧情"],
    image: "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20film%20still%2C%20diver%20descending%20into%20deep%20blue%20ocean%20with%20sun%20rays%20and%20schools%20of%20fish%2C%20mysterious%20vast%20atmosphere%2C%20wide%20shot%2C%20high%20detail&width=1600&height=900&seq=yw-hero-04&orientation=landscape",
    logline: "当她潜入最深的海沟，才发现那里藏着一个等待被唤醒的世界。",
  },
  {
    id: "m13",
    title: "极速逃亡",
    year: 2025,
    genres: ["动作", "冒险"],
    image: "https://readdy.ai/api/search-image?query=Cinematic%20action%20film%20still%2C%20muscle%20car%20speeding%20down%20a%20coastal%20highway%20at%20sunset%2C%20motion%20blur%2C%20warm%20dramatic%20light%2C%20wide%20sweeping%20shot%2C%20high%20detail&width=1600&height=900&seq=yw-hero-05&orientation=landscape",
    logline: "油门踩到底的那一刻，退路就已经被远远甩在了身后。",
  },
];